import { PetitumRevisione } from './petitum-revisione';
import { SpeseDiGiudizio } from './sezioni/spese-giudizio';
import { GradoRischio } from './tipologiche/grado-rischio';
import { SpesaLegale } from "./tipologiche/spesa-legale";
import { TipoPetitum } from './tipologiche/tipo-petitum';

export class Petitum {
  id: string;
  tipoPetitum: TipoPetitum;
  importoPetitum:  number | string;
  maggiorDanno?:  number | string;
  speseLegali: SpesaLegale[];
  importoPattuito?:  number | string;
  interessiPetitum:  number | string;
  interessiSpeseLegali?:  number | string;
  dataInizioCalcoloInteressi: number;
  dataInizioCalcoloInteressiSpeseLegali?: number;
  dataInizioCalcoloInteressiMaggiorDanno?: number;
  dataInizioCalcoloInteressiRivalutazione?:number;
  // campi aggiunti:
  compensi:  number | string;
  compensiLegali:  number | string;
  spese: number | string;
  altro: number | string;
  //
  gradoRischio: GradoRischio;
  percentualeSoccombenza: any;
  accantonamentoPetitum: any;
  accantonamentoInteressi: any;
//  accantonamentoCostiGestione: any;
  accantonamentoCompensiSpeseTotale: any;
  petitumRevisioni: PetitumRevisione[];
  fondoRischi: boolean;
  costiGestione:  number | string;
  speseRegistrazione:  number | string;
  contributoUnificato:  number | string;
  altroImporto:  number | string;
  note:  string;
  speseGiudizio?: SpeseDiGiudizio[];
}
